import dayjs from 'dayjs';

/** Earliest fulfillment date offset — same rule as neopak-forms OrderDetails. */
export const EARLIEST_ORDER_DATE_OFFSET_DAYS = 18;

export const ORDER_DATE_CONFIGURATION_KEY = 'orderDate';

export const getEarliestOrderDate = (from: Date = new Date()) =>
	dayjs(from).add(EARLIEST_ORDER_DATE_OFFSET_DAYS, 'day').startOf('day').toDate();

export const getEarliestOrderDateValue = (from: Date = new Date()) =>
	dayjs(getEarliestOrderDate(from)).format('YYYY-MM-DD');

export const parseOrderDateValue = (value: string | number | null | undefined) => {
	if (value == null || value === '') return null;
	const parsed = dayjs(String(value));
	return parsed.isValid() ? parsed.startOf('day') : null;
};

/** Returns a valid order date string (YYYY-MM-DD), never earlier than today + 18 days. */
export const resolveOrderDateValue = (value: string | number | null | undefined) => {
	const earliest = dayjs(getEarliestOrderDate());
	const parsed = parseOrderDateValue(value);
	if (!parsed || parsed.isBefore(earliest, 'day')) {
		return earliest.format('YYYY-MM-DD');
	}
	return parsed.format('YYYY-MM-DD');
};
